import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import "./style.scss"

class SelectedDate extends Component {
  static propTypes = {
    date: PropTypes.string.isRequired,
    resetHandler: PropTypes.func.isRequired,
    performance: PropTypes.bool,
  }

  state = {
    animate: true,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.date !== this.props.date) {
      this.setState({ animate: false })

      window.requestAnimationFrame(() => {
        this.setState({ animate: true })
      })
    }
  }

  render() {
    const { date, resetHandler, performance } = this.props
    const { animate } = this.state

    return <div className="components_selected-date">
      {performance ? "showing through" : "on"}
      <span className={classNames("date", { "animate-date": animate })}>{formatLongDate(date)}</span>
      <i className="fa fa-repeat" onClick={resetHandler} />
    </div>
  }
}

export default SelectedDate
